import gql from 'graphql-tag';

export default gql`
  query ordersExportV2($sort: [OrderSort], $filter: OrderFilterInput, $regionCodes: [String]) {
    ordersExportV2(sort: $sort, filter: $filter, regionCodes: $regionCodes) {
      content
    }
  }
`;
